export const STAGE_1_IS_PRESS = "isPressed";
export const STAGE_2_BUTTON_PRESS = "02_ButtonIsPressed";
export const STAGE_FDA_IS_CORRECT = "03_isCorrect";
export const STAGE_EXEC_PRESS = "04_ButtonIsPressed";
export const cytiva_databridge = require("src/assets/rive/12285_cytiva_databridge_03_EmbeddedFonts.riv");
